import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "audits";

export const getAuditsList = async (filter: any = {}, sort: any = {}) => {
	try {
		const response = await axios.get(`${url}/${apiURL}`, {
			params: { filter: JSON.stringify(filter), sort: JSON.stringify(sort) },
			...AuthHeader,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const addAuditsItem = async (
	data: any,
	user: any,
	tenantKey: string
) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	data.report_type = "audit";
	data.primary_author = user?.email?.toLowerCase();
	delete data.author;
	try {
		const response = await axios.post(
			`${url}/${apiURL}/add`,
			{ data, user: { email: user?.email, name: user?.name } },
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const updateAudits = async (
	id: string,
	data: any,
	options: any = {}
) => {
	try {
		const response = await axios.put(
			`${url}/${apiURL}`,
			{
				filter: { _id: id },
				data: data,
				options: options,
			},
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const updateAuditsItem = async (
	id: string,
	data: any,
	user: any,
	tenantKey: string,
	options: any = { upsert: true, new: true }
) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	try {
		const response = await axios.put(
			`${url}/${apiURL}/update`,
			{
				filter: { _id: id },
				data,
				user: { email: user?.email, name: user?.name },
				options,
			},
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const deleteAuditsItem = async (id: any, tenantKey: any) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	try {
		const response = await axios.post(
			`${url}/${apiURL}/delete`,
			{ filter: { _id: id } },
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};
